import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    marginBottom: theme.spacing(1.5),
  },
}))
